<template>
	<div id="presets"> 
		<div class="flex space v-top">
			<div>
				<div class="flex v-center">
					<a :href="locale.home_url">
						<svg class="logo" width="80" height="22" viewBox="0 0 80 22" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M58.1818 21.9078H76.3633C78.3718 21.9078 80 20.2731 80 18.2568C80 16.2404 78.3718 14.6058 76.3633 14.6058H59.9995L50.1818 1.46374C48.9766 -0.149098 46.6978 -0.47627 45.0907 0.733661C44.9833 0.811213 44.7926 0.976617 44.7015 1.07295L36.3636 9.44371V3.65398C36.3636 1.63823 34.7353 0.00358223 32.7275 0.00358223C31.8838 -0.0467054 30.7172 0.4386 30.156 1.07295L21.8181 9.44371V3.65398C21.8181 1.63823 20.1898 0.00358223 18.182 0.00358223C17.3383 -0.0467054 16.1724 0.4386 15.6105 1.07295L1.06502 15.6757C-0.355007 17.1014 -0.355007 19.4128 1.06502 20.8384C2.48505 22.264 4.78739 22.264 6.20742 20.8384L14.5453 12.4676V18.2568C14.5453 20.2731 16.1736 21.9078 18.182 21.9078C19.0257 21.9581 20.1917 21.4727 20.7535 20.8384L29.0914 12.4676V18.2568C29.0914 20.2731 30.7197 21.9078 32.7281 21.9078C33.5718 21.9581 34.7377 21.4727 35.2996 20.8384L46.8807 9.21166L55.2741 20.447C55.8462 21.3092 57.1534 21.9647 58.1836 21.9072L58.1818 21.9078Z" fill="black"/>
						</svg>
					</a>
					
					<div class="language-selector flex">
						<a v-for="(url, l) in locale.urls" class="language" :class="{current : l == locale.language}" :href="url">{{ l }}</a>
					</div>
				</div>
				
				<h2 class="huge-font">{{locale.customize}} <br>MULTIDOT</h2>
			</div>
			
			<div class="flex v-center">
				<div class="col-padding">{{ locale.load_configuration }}</div>
				<div class="advanced button" @click="load_modal = true">
					{{ locale.load }}
				</div>
			</div>
		</div>
		
		<div class="container flex h-center column">
			<div class="title">
				<div class="large-font">{{locale.select_preset}}</div>
			</div>
			
			<div class="presets flex h-center">
				<div v-for="(data, i) in presets" class="preset v-center">
					<div class="image" @click="startConfiguration(false, data)">
						<img :src="require('../assets/preset-'+i+'.png')" />
					</div>	
					<div class="text" v-html="locale['preset_text_default_'+i]"></div>
				</div>	
			</div>
		</div>
		
		<div class="load-modal flex v-center h-center" v-if="load_modal" @click.stop="load_modal = false">
			<div class="modal">
				<div class="large-font">{{locale.load_file}}</div>
				<div class="text medium-font">{{locale.load_modal_text}}</div>
				<input type="file" accept=".json" ref="file_input" @change="importFile" hidden/>
				<div class="button filled large" @click="loadFile">{{locale.load}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	
	export default {
		name: 'Presets',
		data: function () { return {
			load_modal : false,
			presets : [
				'{"type":"default","light_color":2700,"room_height":"360","room_decoration":"Tavolo_piccolo","bounds":{"height":197.9999942779541,"width":31,"depth":31.000000000000007},"cables":[{"index":0,"type":"detached","length":370,"offset":192,"lights_number":8,"position":{"x":8.572527703398379e-16,"y":-4.349999999999994,"z":14.000000000000004}},{"index":1,"type":"detached","length":370,"offset":202,"lights_number":8,"position":{"x":-14,"y":5.650000000000006,"z":1.7145055406796762e-15}},{"index":2,"type":"detached","length":370,"offset":172,"lights_number":8,"position":{"x":-2.5717582580799545e-15,"y":-24.349999999999994,"z":-14.000000000000004}},{"index":3,"type":"detached","length":370,"offset":182,"lights_number":8,"position":{"x":14,"y":-14.349999999999994,"z":-3.4290110813593524e-15}}]}',
				'{"type":"default","room_height":"360","room_decoration":"Tavolo_piccolo","light_color":2700,"bounds":{"height":160.19678839803044,"width":170.0245819091797,"depth":170.0245819091797},"cables":[{"index":0,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":59.979785967534276,"y":44.372215236849016,"z":59.97978596753426}},{"index":1,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":5.1939858910294956e-15,"y":44.372215236849016,"z":84.82422678352242}},{"index":2,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":-59.97978596753427,"y":44.372215236849016,"z":59.979785967534276}},{"index":3,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":-84.82422678352242,"y":44.372215236849016,"z":1.0387971782058991e-14}},{"index":4,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":-59.97978596753427,"y":44.372215236849016,"z":-59.979785967534276}},{"index":5,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":-3.2475537957407493e-14,"y":44.372215236849016,"z":-84.82422678352242}},{"index":6,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":59.97978596753427,"y":44.372215236849016,"z":-59.979785967534276}},{"index":7,"type":"attached","length":370,"offset":156,"lights_number":12,"position":{"x":84.82422678352242,"y":44.372215236849016,"z":-3.0193324791283323e-14}}]}',
				'{"type":"default","room_height":400,"room_decoration":"Tavolo_grande","light_color":2700,"bounds":{"height":209.6326974512569,"width":290.82379150390625,"depth":251.9169921875},"cables":[{"index":0,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":69.22950227924828,"y":33.25374301555651,"z":39.969672887163206}},{"index":1,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":72.61269924101758,"y":114.02983659760463,"z":125.76888086624459}},{"index":2,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":2.2644973175033268e-14,"y":33.25374301555651,"z":79.93934410876331}},{"index":3,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":-72.6126992410176,"y":114.02983659760463,"z":125.76888086624459}},{"index":4,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":-69.22950227924825,"y":33.25374301555651,"z":39.969672887163235}},{"index":5,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":-145.22539545621524,"y":114.02983659760463,"z":1.7784981570036258e-14}},{"index":6,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":-69.22950227924825,"y":33.25374301555651,"z":-39.969672887163235}},{"index":7,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":-72.6126992410176,"y":114.02983659760463,"z":-125.76888086624457}},{"index":8,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":-3.26405569239796e-14,"y":33.25374301555651,"z":-79.93934410876331}},{"index":9,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":72.61269924101758,"y":114.02983659760463,"z":-125.76888086624459}},{"index":10,"type":"attached","length":370,"offset":93,"lights_number":16,"position":{"x":69.22950227924825,"y":33.25374301555651,"z":-39.969672887163235}},{"index":11,"type":"attached","length":370,"offset":114,"lights_number":16,"position":{"x":145.22539545621524,"y":114.02983659760463,"z":-3.556996359386829e-14}}]}',
				'{"type":"default","light_color":2700,"room_height":"500","room_decoration":"Divani","bounds":{"height":369.01880645751953,"width":112.26203918457031,"depth":194.14474487304688},"cables":[{"index":0,"type":"detached","length":370,"offset":94,"lights_number":16,"position":{"x":12.12435531616211,"y":-95.35,"z":7.000000000000002}},{"index":1,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":55.93319849430856,"y":103.27319637685746,"z":96.87913893063153}},{"index":2,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":3.360155205369979e-15,"y":42.4726106893825,"z":54.87549892278247}},{"index":3,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":-55.93319849430857,"y":103.27319637685746,"z":96.87913893063153}},{"index":4,"type":"detached","length":370,"offset":94,"lights_number":16,"position":{"x":-12.12435531616211,"y":-125.35,"z":7.000000000000002}},{"index":5,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":-54.87549892278247,"y":42.4726106893825,"z":6.720310410739958e-15}},{"index":6,"type":"detached","length":370,"offset":94,"lights_number":16,"position":{"x":-12.12435531616211,"y":-115.35,"z":-7.000000000000002}},{"index":7,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":-55.93319849430858,"y":103.27319637685746,"z":-96.87913893063151}},{"index":8,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":-2.042810365310288e-14,"y":42.4726106893825,"z":-54.87549892278247}},{"index":9,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":55.93319849430856,"y":103.27319637685746,"z":-96.87913893063153}},{"index":10,"type":"detached","length":370,"offset":94,"lights_number":16,"position":{"x":12.12435531616211,"y":-105.35,"z":-7.000000000000002}},{"index":11,"type":"attached","length":370,"offset":94,"lights_number":16,"position":{"x":54.87549892278247,"y":42.4726106893825,"z":-1.3440620992953163e-14}}]}',
			],
		}},
		computed: {
			...mapState([
				'locale'
			]),
		},
		methods: {
			startConfiguration(advanced, data){
				this.$emit('startConfiguration', true, data);
			},
			loadFile(){
				this.$refs.file_input.click();
			},
			importFile(e){
				var reader = new FileReader();
				reader.onload = this.onReaderLoad;
				reader.readAsText(event.target.files[0]);
			},
			onReaderLoad(e){
				let parsed_data = JSON.parse(event.target.result);
				this.startConfiguration(parsed_data.advanced_mode, event.target.result);
			}
		}
	}
</script>

<style scoped lang="scss">
	#presets{
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding: 20px;
		background: #ffe100;
		z-index: 10;
		overflow-y: auto;
		
		h2{
			margin-bottom: 50px;
		}
		
		.container{
			height: 100%;
						
			.title{
				width: 1230px; 
				margin: 0 auto;
				align-items: start;
			}
			
			.presets{
				margin-top: 50px;
				gap: 50px;
				flex-wrap: wrap;
				
				.preset{
					display: flex;
					flex-direction: column;
					justify-content: center;
					position: relative;
					width: 270px;
						
					.text{
						margin-top: 25px;
					}
					
					.image{
						position: relative;
						background: white;
						width: 100%;
						height: 384px;
						cursor: pointer;
						opacity: 1;
						transition: opacity 0.2s;
						
						&:hover{
							opacity: 0.5;
						}
						
						img{
							position: absolute;
							top: 0;
							left: 0;
							height: 100%;
							width: 100%;
							object-fit: cover;
						}
					}
				}
			}
		}
		
		.language-selector{	
			font-size: 16px;
			background: white;
			border-radius: 24px;
			margin-left: 20px;
			
			.language{
				border-radius: 24px;
				padding: 8px 24px;
				text-align: center;
				width: 100%;
				cursor: pointer;
				white-space: nowrap;
				text-transform: uppercase;
				text-decoration: none;
		
				&:hover{
					background: #D4D4D4;
				}
				  
				&.current{
					background: black;
					color: white;
					cursor: default;
					pointer-events: none;
				}
			}
		}
		
		.load-modal{
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: rgba(0,0,0,0.5);
			
			
			.modal{
				max-width: 500px;
				background: #EDEDED;
				border-radius: 16px;
				padding: 40px;
				
				.text{
					margin: 24px 0;
				}
			}
		}
	}
	
	@media screen and (max-width: 1269px) {
		#presets .container{
			margin-top: 150px;
						
			.title{
				width: 910px; 
			}
		}
	}
	
	@media screen and (max-width: 949px) {
		#presets{
			h2{
				font-size: 5rem;
			}
			.container{
				margin-top: 150px;
							
				.title{
					width: 590px; 
				}
			}
		}
	}

	
</style>
